import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import { SHIPMENT_INITIATED_BY } from 'domains/customer-refund/constants'
import CustomerRefundShipmentInitiatedBy from 'domains/customer-refund/constants/atoms/initiated-by-badge'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  handleSelectRow    : PropTypes.func,
  isShipmentItems    : PropTypes.bool,
  refundRequestIds   : PropTypes.array,
  selectedCustomerId : PropTypes.string,
  selectedShippingId : PropTypes.string
}

const defaultProps = {
  handleSelectRow    : () => {},
  isShipmentItems    : false,
  refundRequestIds   : [],
  selectedCustomerId : '',
  selectedShippingId : ''
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}


/**
 * Columns definition for Customer Refund Shippable
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const CustomerRefundShippableTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {


  // eslint-disable-next-line react/prop-types
  const InitiatedByFilter = ({ column }) => {
    const options = Object.keys(SHIPMENT_INITIATED_BY).map((key) => (
      {
        label : SHIPMENT_INITIATED_BY[key],
        value : SHIPMENT_INITIATED_BY[key]
      }
    ))
    return (
      <SelectTableFilter
        reactTableColumn={ column }
        options={ options }
      />
    )
  }

  const InitiatedByCell = (row) => <CustomerRefundShipmentInitiatedBy initiated_by={ row.cell.value } />

  // Custom Cell
  // Used to modify the cell in specific columns
  const AddressCell = (data) => {
    const address = data.row.values.shipping_address

    if (address) {
      return ([
        address.street_address,
        address.sub_district,
        address.district,
        address.province,
        address.postal_code
      ].join(', '))
    }
    return ''
  }

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {

    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <>
        <RowButton
          // eslint-disable-next-line react/prop-types
          data={ row.original }
          color={ buttonColour }
          disabled={ disabled }
          onClick={ onButtonClick }
          text={ buttonText }
        />
      </>
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Number',
        accessor : 'number'
      },
      {
        Header   : 'Customer Name',
        accessor : 'customer.name'
      },
      {
        Header   : 'Product SKU',
        accessor : 'product_sku'
      },
      {
        Header   : 'Initiated By',
        accessor : 'initiated_by',
        Filter   : InitiatedByFilter,
        Cell     : InitiatedByCell
      },
      {
        Header         : 'Address',
        accessor       : 'shipping_address',
        Cell           : AddressCell,
        disableFilters : true
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

CustomerRefundShippableTableColumns.propTypes    = propTypes
CustomerRefundShippableTableColumns.defaultProps = defaultProps

export default CustomerRefundShippableTableColumns